export const EVENTS_ENUM = {
  VERIFICATION: 'verification',
}
